var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseListV2',{attrs:{"model-class":_vm.ObjectAuthorization,"collection-filter":_vm.filter,"has-detail-view":false,"help-message":"Object Authorizations grant the permissions defined in a role to a selection of objects from the system."}})}
var staticRenderFns = []

export { render, staticRenderFns }